var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"docWrap",staticStyle:{"width":"100%","height":"500px"}},[_c('div',{ref:"file",staticStyle:{"width":"100%","height":"100%","overflow-y":"auto"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }